<template>
  <div id="app">
    <input type="hidden" id="pontuacao" :value="count" />
    <input type="hidden" id="email_to_send" value="" />

    <!--
    <router-link class="nav-link" active-class="active" to="/page1">Page 1</router-link>
    <router-link class="nav-link" active-class="active" to="/page2">Page 2</router-link>
    <router-link class="nav-link" active-class="active" to="/page2">Page 3</router-link>
    -->

    <transition name="fade">
      <router-view></router-view>
    </transition>

    <div class="clearfix"></div>

    <div id="footer">
        <div class="wrapper">
            <b-row id="footer-row">
              <b-col class="text-white copyright">© 2019 Phonak Todos os direitos reservados </b-col>
              <b-col class="order1"><img src="assets/0800.png" /> </b-col>
              <b-col><img src="assets/logo.png" /></b-col>
            </b-row>
        </div>
    </div>
  </div>

</template>

<script>
import { bus } from './main';

export default {
  name: 'app',
  props: {
    utm_source: {
      type: String
    }
  },
  data: function(){
    return {
      questions: [],
      count: 0
    }
  },
  created(){

    /*
    let urlParams = new URLSearchParams(window.location.search);
    let utm_source = urlParams.get('utm_source');

    document.getElementById('utm_source').value = utm_source;


    let uri = window.location.href.split('?');
    console.log(uri);
    if (uri.length == 2)
    {
      let vars = uri[1].split('&');
      let getVars = {};
      let tmp = '';
      vars.forEach(function(v){
        tmp = v.split('=');
        if(tmp.length == 2)
        getVars[tmp[0]] = tmp[1];
      });
      console.log(getVars);
      // do
    }
    */

    bus.$on('computaPontuacao', (data) => {
      //console.log(data);
      //console.log(data.question + ' = ' + data.answer);
      this.questions[data.question] = data.answer;
      console.log(this.questions);
      //this.questions.forEach()
      this.count = 0;
      for (var data in this.questions) {
        this.count += this.questions[data];
        //console.log('#' + this.questions[data]);
      }
    })
  },
  methods: {
        incrementCounter: function() {
          console.log('incrementar porra');
          console.log(this.count);
            this.count += 1;
            console.log(this.count);
        }
    }
}
</script>

<style>
@font-face {
  font-family: 'rotissansnormal';
  src: url(/teste-auditivo/assets/fontes/Rotis-SemiSerif.ttf) format('truetype');
}
@font-face {
  font-family: 'rotissansbold';
  src: url(/teste-auditivo/assets/fontes/RFB_____.ttf) format('truetype');
  font-weight: bold;
}
@font-face {
  font-family: 'phonaknormal';
  src: url(/teste-auditivo/assets/fontes/Phr_____.ttf) format('truetype');;
}




.btn {
  font-family: 'phonaknormal' !important;
  font-size:22px !important;
  padding-top: 5px !important;
  padding-bottom: 4px !important;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'rotissansnormal';
}

h1 {
  font-family: 'rotissansbold';
  text-align: left;
  padding-bottom: 30px;
}

.clearfix{
  clear: both;
}
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

.page-container {
  max-width: 1170px;
  margin:0 auto;
  /*height: calc(100vh - 120px);*/
  height: 780px;
  max-height: 780px;
  border:0px solid;
  /*padding-top:35px;*/
  text-align: center;
  /*background-image: url({{ bg_image }});*/
  background-repeat: no-repeat;
  padding-bottom: 30px;
}

.wrapper {
  max-width: 1170px;
  margin:0 auto;
}
#footer {
  padding-top:35px;
  width:100%;
  height:120px;
  background-color: #96c303;
  text-align: center;

  /*
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  margin-bottom: 0px;
  */
}
.box {
  margin-top:0px;
  text-align: left;
  overflow: auto;
  display: block;

  /*width: calc(100% - 460px) !important;*/
}

#page1 .box,
#page2 .box,
#page3 .box,
#page4 .box,
#page5 .box,
#page6 .box,
#page7 .box,
#page8 .box,
#page9 .box,
#page10 .box,
#cadastre .box {
  background: white !important;
  padding: 0px 0px;
  height: 780px;
}

.text-white {
  color: #fff;
}
.text-green {
  color: #96c303;
}
.text-gray {
  color: #93918a;
}
.bg-green {
  background-color: #cbe086;
}
.m-t-10{
  margin-top:10px;
}
.m-t-20{
  margin-top:20px;
}
.m-t-30{
  margin-top:30px;
}
.m-t-40{
  margin-top:40px;
}
.m-t-50{
  margin-top:50px;
}
.m-t-60{
  margin-top:60px;
}
.m-t-70{
  margin-top:70px;
}
.m-t-80{
  margin-top:80px;
}
.m-t-90{
  margin-top:90px;
}
.m-t-100{
  margin-top:100px;
}
.m-t-140{
  margin-top:140px;
}
.m-l-70{
  margin-left:70px;
}
.m-l-60{
  margin-left:60px;
}
.p-b-0 {
  padding-bottom: 0;
}
.w-45 {
  width: 45% !important;
}
.w-35 {
  width: 35% !important;
}
.w-55 {
  width: 55% !important;
}
.w-76 {
  width: 76%;
}
.w-660px {
  width: 660px !important;
}
.w-516px {
  width: 516px !important;
}
.w-585px {
  width: 585px !important;
}
.boldit {
  font-size: 1.3rem !important;
}

.copyright {
  margin-top:10px;
}

.pull-right {
  float:right;
}

.pull-left {
  float:left;
}

.btn-secondary {
  background-color: #b4b4b4 !important;
  border-color: #b4b4b4 !important;
}

.btn-success {
  background-color: #96c303 !important;
  border-color: #96c303 !important;
}


@media only screen
  and (max-width: 1000px) {
  br {
    display: none;
  }

  #page1 .box,
  #page2 .box,
  #page3 .box,
  #page4 .box,
  #page5 .box,
  #page6 .box,
  #page7 .box,
  #page8 .box,
  #page9 .box,
  #page10 .box,
  #cadastre .box {
    padding: 0px 20px !important;
  }
}

@media only screen
  and (max-width: 599px) {


    .w-660px {
      width: 99% !important;
    }
    .w-516px {
      width: 99% !important;
    }
    .w-585px {
      width: 99% !important;
    }
    .w-76 {
      width: 95% !important;
    }

    .m-t-50{
      margin-top:10px;
    }
    .m-t-60{
      margin-top:20px;
    }
    .m-t-70{
      margin-top:30px;
    }
    .m-t-80{
      margin-top:35px;
    }
    .m-t-90{
      margin-top:25px;
    }

    #page1.page-container,
    #page2.page-container,
    #page3.page-container,
    #page4.page-container,
    #page5.page-container,
    #page6.page-container,
    #page7.page-container,
    #page8.page-container,
    #page9.page-container,
    #page10.page-container {
      background: none !important;
    }

    #page1.page-container h1,
    #page2.page-container h1,
    #page3.page-container h1,
    #page4.page-container h1,
    #page5.page-container h1,
    #page6.page-container h1,
    #page7.page-container h1,
    #page8.page-container h1,
    #page9.page-container h1,
    #page10.page-container h1{
      text-align: center;
    }


    #footer {
      padding-top:2px;
      width:100%;
      height:150px;
      background-color: #96c303;
      text-align: center;

      /*
      position: fixed;
      bottom: 0px;
      left: 0px;
      right: 0px;
      margin-bottom: 0px;
      */
    }

    #footer-row {
      display: -webkit-flex;
      -webkit-flex-direction: column-reverse;
      -webkit-flex-flow: column-reverse wrap; /* Safari 6.1+ */
      display: flex !important;
      flex-direction: column-reverse;
      flex-flow: column-reverse;
    }
    #footer-row .order1 {
      order: 1;
    }
    #footer-row div {

      margin-top:10px;
    }
}

@media only screen
  and (min-width: 1600px) {
      /**
      * RESULTADOS
      */
      #resultado-left-box {
        width: 960px !important;
      }
}
</style>

<!--
$2y$10$G8hukh6wKqk1gk8yJzBu/OncA6c30O581.CHVkAblfEBhyrsj8bLK
-->
